<template>
    <v-container v-if="isLoaded" fluid class="editBusiness">
        <v-row wrap>
            <v-col cols="12">
                <v-card>
                    <v-toolbar flat color="white">
                        <v-btn v-if="editMode" color="primary" text @click="$router.push({ name: 'businesses.details' })"><v-icon>keyboard_arrow_left</v-icon>Business info </v-btn>
                        <v-btn v-else color="primary" text @click="$router.push({ name: 'businesses' })"><v-icon>keyboard_arrow_left</v-icon>Businesses </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="pink" class="white--text" @click="save()">Save</v-btn>
                    </v-toolbar>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Basic Info</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-row class="mx-2">
                        <v-col cols="6">
                            <v-row dense>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        class="my-0"
                                        v-model="businessObject.name"
                                        :rules="[rules.name_rule, rules.required]"
                                        :label="$t('editBusiness.info.name')"
                                        :placeholder="$t('editBusiness.info.name')"
                                        color="secondary"
                                        prepend-icon="label"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        class="my-0"
                                        v-model="getBusinessImageName"
                                        :label="$t('editBusiness.info.logo')"
                                        :value="businessObject.profile_picture"
                                        :placeholder="$t('editBusiness.info.logo')"
                                        color="secondary"
                                        prepend-icon="insert_photo"
                                        @click="pickFile"
                                    />
                                    <input ref="image" type="file" style="display: none" accept="image/*" @change="setImage" />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        class="my-0"
                                        :min="1"
                                        :max="5"
                                        v-model="businessObject.price_range"
                                        :rules="[rules.price_rule, rules.required]"
                                        :label="$t('editBusiness.info.price')"
                                        type="number"
                                        :placeholder="$t('editBusiness.info.price')"
                                        color="secondary"
                                        prepend-icon="attach_money"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.phone"
                                        :rules="[rules.required]"
                                        :label="$t('editBusiness.info.phone')"
                                        :placeholder="$t('editBusiness.info.phone')"
                                        prepend-icon="phone"
                                        color="secondary"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.score"
                                        :rules="[rules.required]"
                                        :label="$t('editBusiness.info.score')"
                                        :placeholder="$t('editBusiness.info.score')"
                                        prepend-icon="trending_up"
                                        color="secondary"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.website"
                                        :label="$t('editBusiness.info.website')"
                                        :placeholder="$t('editBusiness.info.website')"
                                        color="secondary"
                                        prepend-icon="web"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.email"
                                        :label="$t('editBusiness.info.email')"
                                        :placeholder="$t('editBusiness.info.email')"
                                        color="secondary"
                                        prepend-icon="alternate_email"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.facebook_url"
                                        :label="$t('editBusiness.info.facebook')"
                                        :placeholder="$t('editBusiness.info.facebook')"
                                        prepend-icon="facebook"
                                        color="secondary"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.instagram_url"
                                        :label="$t('editBusiness.info.instagram')"
                                        :placeholder="$t('editBusiness.info.instagram')"
                                        prepend-icon="g_translate"
                                        color="secondary"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="businessObject.tags"
                                        :items="tags"
                                        item-text="name"
                                        item-value="id"
                                        :rules="[rules.tags_rule, rules.required]"
                                        :label="$t('editBusiness.info.mainCategories')"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        color="secondary"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="businessObject.facility_options"
                                        :items="getFacilityOptions"
                                        item-text="name"
                                        item-value="id"
                                        label="Επιλογές εγκαταστάσεων"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        color="secondary"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="businessObject.service_options"
                                        :items="getServiceOptions"
                                        item-text="name"
                                        item-value="id"
                                        label="Επιλογές υπηρεσιών"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        color="secondary"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="businessObject.parking_options"
                                        :items="getParkingOptions"
                                        item-text="name"
                                        item-value="id"
                                        label="Επιλογές parking"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        color="secondary"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="businessObject.good_for_options"
                                        :items="getGoodForOptions"
                                        item-text="name"
                                        item-value="id"
                                        label="Επιλογές καταλληλότητας"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        color="secondary"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="businessObject.meal_options"
                                        :items="getMealOptions"
                                        item-text="name"
                                        item-value="id"
                                        label="Επιλογές γευμάτων"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        color="secondary"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="businessObject.food_options"
                                        :items="getFoodOptions"
                                        item-text="name"
                                        item-value="id"
                                        label="Επιλογές φαγητού"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        color="secondary"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <v-row>
                                <v-col class="imageBackground">
                                    <v-card class="clickable_card mx-2 my-2" tile>
                                        <v-img ref="imageId" :src="getBusinessImage" height="350px" />
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card class="card">
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Location Info</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-row wrap class="mx-2">
                        <v-col cols="12">
                            <v-list two-line>
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">pin_drop</v-icon>
                                    </v-list-item-action>
                                    <v-text-field
                                        dense
                                        ref="addressField"
                                        v-model="place"
                                        label="Address"
                                        hint="Type the address and then hit enter"
                                        persistent-hint
                                        @keyup.enter.native="triggerPlaceChangeEvent(place)"
                                    ></v-text-field>
                                    <v-btn dark outlined class="ml-4" color="primary" style="margin-top: -20px;" @click="triggerPlaceChangeEvent(place)">Find address</v-btn>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col cols="6">
                            <gmap-map :center="center" :zoom="18" :options="mapOptions" style="width:100%;  height: 230px; margin-bottom: 5px;">
                                <gmap-marker
                                    v-for="(m, index) in markers"
                                    :key="index"
                                    :position="m.position"
                                    :clickable="true"
                                    :draggable="true"
                                    @click="center = m.position"
                                    @dragend="drag"
                                />
                            </gmap-map>
                        </v-col>
                        <v-col cols="6">
                            <v-row dense wrap>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.country"
                                        :label="$t('editBusiness.locationTab.country')"
                                        :placeholder="$t('editBusiness.locationTab.country')"
                                        prepend-icon="flag"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.city"
                                        :label="$t('editBusiness.locationTab.city')"
                                        :placeholder="$t('editBusiness.locationTab.city')"
                                        prepend-icon="location_city"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.zip_code"
                                        :label="$t('editBusiness.locationTab.zip')"
                                        :placeholder="$t('editBusiness.locationTab.zip')"
                                        prepend-icon
                                        style="margin-left: 20px;"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.address"
                                        :label="$t('editBusiness.locationTab.address')"
                                        :placeholder="$t('editBusiness.locationTab.address')"
                                        prepend-icon="directions"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.longitude"
                                        :label="$t('editBusiness.locationTab.longitude')"
                                        :placeholder="$t('editBusiness.locationTab.longitude')"
                                        prepend-icon="pin_drop"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        dense
                                        v-model="businessObject.latitude"
                                        :label="$t('editBusiness.locationTab.latitude')"
                                        :placeholder="$t('editBusiness.locationTab.latitude')"
                                        style="margin-left: 20px;"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Business Hours</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-row class="mx-2">
                        <v-col cols="12">
                            <v-list>
                                <v-list-item v-for="item in schedule" :key="item.day">
                                    <template>
                                        <v-list-item-action>
                                            <v-checkbox v-model="item.active" :label="$t(item.day)" color="primary" style="min-width:150px;"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content style="margin:10px;">
                                            <v-text-field
                                                :label="$t('editBusiness.workingHoursTab.fromTime')"
                                                v-model="item.fromTime"
                                                mask="time"
                                                placeholder="##:##"
                                            ></v-text-field>
                                        </v-list-item-content>
                                        <v-list-item-content style="margin:10px;">
                                            <v-text-field :label="$t('editBusiness.workingHoursTab.toTime')" v-model="item.toTime" mask="time" placeholder="##:##"></v-text-field>
                                        </v-list-item-content>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as R from 'ramda';
import { mapGetters } from 'vuex';
import bus from '../../../main';
import { BusinessesApi } from '@/api';
import { dates, fonts, filters } from '@/utils/mixins';

export default {
    name: 'EditBusiness',
    mixins: [dates, fonts, filters],
    data: () => ({
        headers: [
            {
                text: 'Checkbox',
                align: 'start',
                value: 'active',
            },
            { text: 'From time', value: 'fromTime' },
            { text: 'To time', value: 'toTime' },
        ],
        isLoaded: false,
        editMode: false,
        businessObject: {},
        tags: [],
        schedule: [],
        center: {
            lat: 45.508,
            lng: -73.587,
        },
        markers: [],
        places: [],
        place: null,
        currentPlace: null,
        mapOptions: {
            disableDefaultUI: true,
        },
        getBusinessImageNameValue: null,
        imageUrl: require('../../../assets/main.jpg'),
        rules: {
            required: value => !!value || 'Required',
            name_rule: v => {
                if (v !== undefined && v !== null && v.length >= 3 && v.length <= 32) {
                    return true;
                }
                return 'Name between 3 and 32';
            },
            tags_rule: v => {
                if (v !== null && v.length < 6 && v.length > 0) {
                    return true;
                }
                return 'Tags between 1 and 3';
            },
            price_rule: v => {
                if (v !== null && v <= 4 && v >= 0) {
                    return true;
                }
                return 'Price between 0 and 4';
            },
        },
    }),
    computed: {
        ...mapGetters('BusinessOptions', {
            getTags: 'getTags',
            getServiceOptions: 'getServiceOptions',
            getFacilityOptions: 'getFacilityOptions',
            getParkingOptions: 'getParkingOptions',
            getGoodForOptions: 'getGoodForOptions',
            getMealOptions: 'getMealOptions',
            getFoodOptions: 'getFoodOptions',
        }),
        getBusinessImage: {
            get() {
                if (
                    this.businessObject.profile_picture === '' ||
                    this.businessObject.profile_picture === undefined ||
                    this.businessObject.profile_picture === null ||
                    this.businessObject.profile_picture instanceof FormData
                ) {
                    return this.imageUrl;
                }
                return this.businessObject.profile_picture;
            },
        },
        getBusinessImageName: {
            get() {
                return this.getBusinessImageNameValue;
            },
            set(value) {
                this.getBusinessImageNameValue = value;
            },
        },
    },
    watch: {
        getBusinessImage: {
            deep: true,
            handler() {
                this.getBusinessImageName = this.imageName;
            },
        },
        getBusinessImageName: {
            deep: true,
            handler() {
                if (this.businessObject.profile_picture === '' || this.businessObject.profile_picture === null) {
                    this.getBusinessImageNameValue = null;
                } else if (this.businessObject.profile_picture instanceof FormData) {
                    this.getBusinessImageNameValue = this.imageName;
                } else {
                    const savedImageName = this.businessObject.profile_picture.split('/').pop();
                    [this.getBusinessImageNameValue] = savedImageName.split('?');
                }
            },
        },
    },
    async created() {
        this.editMode = this.$route.params.id || false;
        this.tags = this.getTags.filter(tag => tag.only_for_search === false);

        if (this.editMode) {
            const { data: businessObject } = await BusinessesApi.get(this.$route.params.id);
            this.businessObject = businessObject;
        }
        this.schedule = this.formatBusinessHours(this.businessObject);

        this.geolocate();
        this.isLoaded = true;
    },
    methods: {
        drag(location) {
            this.businessObject.latitude = location.latLng.lat();
            this.businessObject.longitude = location.latLng.lng();
        },
        geolocate() {
            if (this.businessObject.latitude && this.businessObject.longitude) {
                const marker = {
                    lat: this.businessObject.latitude,
                    lng: this.businessObject.longitude,
                };
                this.markers.push({ position: marker });
                this.center = marker;
            }
        },
        pickFile() {
            this.$refs.image.click();
        },
        setImage(e) {
            const file = e.target.files[0];
            if (!file.type.includes('image/')) {
                this.imageName = '';
                this.imageUrl = require('../../../assets/main.jpg');
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = event => {
                    this.imageName = e.target.files[0].name;
                    const [imageFile] = e.target.files;
                    this.imageUrl = event.target.result;
                    const formData = new FormData();
                    formData.append('profile_picture', imageFile);
                    this.businessObject.profile_picture = formData;
                };
                reader.readAsDataURL(file);
            } else {
                this.imageName = '';
                this.imageUrl = require('../../../assets/main.jpg');
            }
        },
        async save() {
            this.businessObject.hours = this.serialize_hours(this.schedule);
            if (this.editMode) {
                await this.update();
            } else {
                await this.create();
            }
        },
        async update() {
            if (this.businessObject.profile_picture instanceof FormData) {
                const headers = { 'Content-Type': 'multipart/form-data' };
                await BusinessesApi.updateImage(this.businessObject.id, this.businessObject.profile_picture, headers);
            }
            delete this.businessObject.profile_picture;
            const { data: businessObject } = await BusinessesApi.update(this.businessObject);
            bus.$emit('load-business-event', businessObject);
            this.$router.push({
                name: 'businesses.details',
                params: { id: businessObject.id },
            });
        },
        async create() {
            const clonedBusiness = R.clone(this.businessObject);
            delete clonedBusiness.profile_picture;
            const { data: businessObject } = await BusinessesApi.create(clonedBusiness);

            const image = this.businessObject.profile_picture;
            if (image instanceof FormData) {
                const headers = { 'Content-Type': 'multipart/form-data' };
                await BusinessesApi.updateImage(businessObject.id, image, headers);
            }

            bus.$emit('load-business-event', businessObject);
            this.$router.push({
                name: 'businesses.details',
                params: { id: businessObject.id },
            });
        },
        setPlace(place) {
            this.markers = [];
            this.currentPlace = place;
            this.businessObject.address = this.currentPlace.formatted_address;
            this.businessObject.latitude = this.currentPlace.geometry.location.lat();
            this.businessObject.longitude = this.currentPlace.geometry.location.lng();
            this.businessObject.city = this.currentPlace.address_components[2].long_name;
            this.businessObject.region = this.currentPlace.address_components[3].long_name;
            this.businessObject.country = this.currentPlace.address_components[4].long_name;
            this.businessObject.zip_code = this.currentPlace.address_components[5].long_name;
            this.addMarker();
        },
        addMarker() {
            if (this.currentPlace) {
                const marker = {
                    lat: this.currentPlace.geometry.location.lat(),
                    lng: this.currentPlace.geometry.location.lng(),
                };
                this.markers.push({ position: marker });
                this.places.push(this.currentPlace);
                this.center = marker;
                this.currentPlace = null;
            }
        },
        triggerPlaceChangeEvent(address) {
            if (address && address != null && address.length > 5) {
                // eslint-disable-next-line no-undef
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address }, (results, status) => {
                    if (status !== 'OK' || !results[0]) {
                        throw new Error(status);
                    }
                    results[0].formatted_address = address;
                    this.place = results[0].formatted_address;
                    this.setPlace(results[0]);
                    // this.validateForm();
                });
            }
        },
        getDayNumber(day) {
            if (day === 'generic.monday') {
                return 1;
            }
            if (day === 'generic.tuesday') {
                return 2;
            }
            if (day === 'generic.wednesday') {
                return 3;
            }
            if (day === 'generic.thursday') {
                return 4;
            }
            if (day === 'generic.friday') {
                return 5;
            }
            if (day === 'generic.saturday') {
                return 6;
            }
            if (day === 'generic.sunday') {
                return 7;
            }
        },
        serialize_hours(data) {
            const activeDays = [];
            const formattedActiveDays = [];
            for (let index = 0; index < data.length; index++) {
                if (data[index].active === true) {
                    activeDays.push(data[index]);
                }
            }
            for (let i = 0; i < activeDays.length; i++) {
                const item = {};
                item.week_day = this.getDayNumber(activeDays[i].day);
                item.from_time = activeDays[i].fromTime;
                item.to_time = activeDays[i].toTime;
                formattedActiveDays.push(item);
            }
            return formattedActiveDays;
        },
    },
};
</script>

<style lang="scss">
.editBusiness {
    .card {
        height: 450px;
    }
    .imageBackground {
        padding: 0px;
        vertical-align: top;
        display: inline-block;
        text-align: center;
    }
}
</style>
